/* eslint eqeqeq: "off" */
import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { Button, Col, Row } from "antd";
import "./index.css";
import PropTypes from "prop-types";
import { toast, ToastContainer } from "react-toastify";
// import { Importer, ImporterField } from "react-csv-importer";
// theme CSS for React CSV Importer
// import "react-csv-importer/dist/index.css";
import { CSVImporter } from "csv-import-react";
import { useHistory } from "react-router";
import { BulbFilled } from "@ant-design/icons";
import { isEmpty } from "lodash";
import Spreadsheet from "react-spreadsheet";

const SalesReturnImport = (props) => {
  //   const [loading, setLoading] = useState(false);
  // const dispatch = useDispatch();
  const history = useHistory();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  //   const userNameDetails = JSON.parse(userName);

  //   const userOrganisationName = !isEmpty(userNameDetails)
  //     ? userNameDetails.user.organizations[0].organizationName
  //     : "";
  //   const userInfoMobile = !isEmpty(userNameDetails)
  //     ? userNameDetails.user.mobileNo
  //     : "";

  //Props values from parties home

  const importMode =
    props.location && props.location.state ? props.location.state.mode : "";

  //   const organizationId = props.location.state
  //     ? props.location.state.organizationId
  //     : "";

  //   const userId = props.location.state ? props.location.state.userId : "";

  console.log(userName, "userName");
  const salesSnvoiceData =
    props.location && props.location.state
      ? props.location.state.salesInvoice
      : "";

  console.log(salesSnvoiceData, "salesSnvoiceData");
  //Imported section
  const [importPreview, setImportPreview] = useState(false);
  const [importedData, setImportedData] = useState("");
  // const [tableLoading, setTableLoading] = useState(false);

  console.log(importedData, "importedData");

  // const columns = [
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">S.No</p>
  //     ),
  //     key: "sNo",
  //     width: 70,
  //     dataIndex: "sNo",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Vendor Name
  //       </p>
  //     ),
  //     key: "vendorName",
  //     width: 140,
  //     dataIndex: "vendorName",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Purchase Invoice No
  //       </p>
  //     ),
  //     key: "purchaseinvoiceNo",
  //     width: 170,
  //     dataIndex: "purchaseinvoiceNo",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Purchase Invoice Date
  //       </p>
  //     ),
  //     key: "purchaseinvoiceDate",
  //     width: 180,
  //     dataIndex: "purchaseinvoiceDate",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Model Name
  //       </p>
  //     ),
  //     key: "modelName",
  //     width: 140,
  //     dataIndex: "modelName",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">Grade</p>
  //     ),
  //     key: "grade",
  //     width: 140,
  //     dataIndex: "grade",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">RAM</p>
  //     ),
  //     key: "ram",
  //     width: 140,
  //     dataIndex: "ram",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         {importMode == "Qty" ? "Qty" : "IMEI No"}
  //       </p>
  //     ),
  //     key: importMode == "Qty" ? "qty" : "imeiNo",
  //     width: 140,
  //     dataIndex: importMode == "Qty" ? "qty" : "imeiNo",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Purchase Price
  //       </p>
  //     ),
  //     key: "purchaseprice",
  //     width: 140,
  //     dataIndex: "purchaseprice",
  //   },
  //   {
  //     title: (
  //       <p className="header-sales-invoice font-semibold text-[13px]">
  //         Selling Price
  //       </p>
  //     ),
  //     key: "sellingPrice",
  //     width: 140,
  //     dataIndex: "sellingPrice",
  //   },
  // ];

  //data table
  const importedDataTable =
    !isEmpty(importedData) && importedData.rows && importedData.rows.length > 0
      ? importedData.rows.map(
          (data) => {
            // const importedPreviewData = data && data.values ? data.values : "";

            const finalOutput = [
              {
                value: data.values.vendorName,
              },
              { value: data.values.purchaseinvoiceNo },
              { value: data.values.purchaseinvoiceDate },
              { value: data.values.modelName },
              { value: data.values.grade },
              { value: data.values.ram },
              { value: data.values.imeiNo },
              { value: data.values.purchaseprice },
              { value: data.values.sellingPrice },
            ];
            return finalOutput;
          }

          // return {
          //   sNo: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.sNo}
          //     </p>
          //   ),
          //   vendorName: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.vendorName}
          //     </p>
          //   ),
          //   purchaseinvoiceNo: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.purchaseinvoiceNo}
          //     </p>
          //   ),
          //   purchaseinvoiceDate: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.purchaseinvoiceDate}
          //     </p>
          //   ),
          //   modelName: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.modelName}
          //     </p>
          //   ),
          //   grade: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.grade}
          //     </p>
          //   ),
          //   ram: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.ram}
          //     </p>
          //   ),
          //   imeiNo: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.imeiNo}
          //     </p>
          //   ),
          //   purchaseprice: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.purchaseprice}
          //     </p>
          //   ),
          //   sellingPrice: (
          //     <p className="header-sales-invoice font-normal">
          //       {importedPreviewData.sellingPrice}
          //     </p>
          //   ),
          // };
        )
      : [];
  const columnLabels = [
    // "S.No",
    "Vendor Name",
    "Purchase Invoice No",
    "Purchase Invoice Date",
    "Model Name",
    "Grade",
    "RAM",
    importMode == "Qty" ? "Qty" : "IMEI No",
    "Purchase Price",
    "Selling Price",
  ];
  const rowLabels =
    !isEmpty(importedData) && importedData.rows && importedData.rows.length > 0
      ? importedData.rows.map((data) => data.values.sNo)
      : [];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Sales Import | Mbook</title>
        </MetaTags>
      </div>

      <Row className="">
        <Col md={24} lg={24} sm={24} xs={24} className="bg-[white]">
          <Row className="mt-[-4px] bg-[white] flex justify-center purchase-invoice-details-header">
            <Col md={12} className="p-2">
              <div className="font-poppins flex justify-center pl-[20px] pr-[20px]">
                <div>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={
                      importPreview == true
                        ? "text-[16px] text-[#5a95bd] ml-2 font-semibold"
                        : "text-[16px] ml-2 font-semibold"
                    }
                  >
                    {importPreview == true
                      ? "Sales Import - Preview"
                      : "Sales Import"}
                  </h1>
                </div>
              </div>
            </Col>
          </Row>
          {importPreview == true ? (
            <Col md={24} className="bg-[white] h-[430px] mt-3">
              <Row className="purchase-invoice-import-content">
                <Col
                  md={24}
                  lg={24}
                  xs={24}
                  sm={24}
                  className="pointer-events-none opacity-1 pl-4"
                >
                  {/* <Table
                    style={{
                      overflow: "hidden",
                    }}
                    bordered
                    columns={columns}
                    dataSource={importedDataTable}s
                    sortDirections={"ascend"}
                    loading={tableLoading ? true : false}
                    showSorterTooltip={"sorter-icon"}
                    scroll={{ y: 350, x: "max-content" }}
                    pagination={false}
                  /> */}

                  <Spreadsheet
                    data={importedDataTable}
                    columnLabels={columnLabels}
                    DataEditor={false}
                    rowLabels={rowLabels}
                    // className="spreadsheet-column"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={24} lg={24} xs={24} sm={24} className="pr-4 pl-4 mt-5">
                  <div className="w-[100%] flex justify-between">
                    <Button
                      style={{
                        fontFamily: "Poppins",
                      }}
                      onClick={() => setImportPreview(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{
                        fontFamily: "Poppins",
                      }}
                      type="primary"
                      onClick={() => {
                        // setImportPreview(false);
                        toast.info("Sales data imported successfully");
                        setTimeout(() => {
                          history.push("/sales-invoice");
                          setImportPreview(false);
                        }, 1500);
                      }}
                    >
                      Import
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          ) : (
            <Row className="purchase-invoice-details-content">
              <Col md={24} className="h-[370px]">
                {/* Import file */}
                <CSVImporter
                  draggable={true}
                  isModal={false}
                  // color="white"
                  slot=""
                  className="Stepper-module_stepper__2HBhf Main-module_wrapper__33d9J Main-module_content__MK50u mt-[-15px]"
                  primaryColor="white"
                  onComplete={(data) => {
                    console.log(data, "data");
                    setImportedData(data);
                    setImportPreview(true);
                    // setTableLoading(true);
                    // setTimeout(() => {
                    //   setTableLoading(false);
                    // }, 1500);
                    // toast.success("Sales imported successfully");
                    // setTimeout(() => {
                    //   history.push("/purchase-invoice");
                    // }, 2000);
                  }}
                  template={{
                    columns: [
                      {
                        name: "S.No",
                        key: "sNo",
                        required: true,
                        //   description: "Vendor Name",
                      },
                      {
                        name: "Vendor Name",
                        key: "vendorName",
                        required: true,
                        //   description: "Vendor Name",
                      },
                      {
                        name: "Purchase Invoice Number",
                        key: "purchaseinvoiceNo",
                        required: true,
                        //   description: "Invoice Number",
                      },
                      {
                        name: "Purchase Invoice Date",
                        key: "purchaseinvoiceDate",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Model Name",
                        key: "modelName",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Grade",
                        key: "grade",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "RAM",
                        key: "ram",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: importMode == "Qty" ? "Qty" : "IMEI No",
                        key: importMode == "Qty" ? "qty" : "imeiNo",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Purchase Price",
                        key: "purchaseprice",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Selling Price",
                        key: "sellingPrice",
                        required: true,
                        //   description: "amount",
                      },
                    ],
                  }}
                  skipHeaderRowSelection
                />
              </Col>
              <Col md={24} className="purchase-invoice-details-footer">
                <div className="w-[100%]">
                  {/* <div className="pl-[40px] pr-[20px] mt-[-31px] mb-2">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="flex text-[13px] ml-2 font-medium"
                  >
                    Download a{" "}
                    <p className="ml-1 mr-1 text-[#0ba5ec]">template</p> and
                    compare it to your import file to ensure the file perfect
                    for the import
                  </h1>
                </div> */}
                  <div className="w-[100%] flex justify-center p-2">
                    <div className="w-[68%] bg-[#f3f3f3] rounded-lg">
                      <div className="flex font-semibold text-[16px] pl-1 pt-1 pr-2 mb-[-11px]">
                        <BulbFilled className="mr-2 text-[#e7e72d]" /> Page Tips
                      </div>
                      <ul
                        style={{
                          listStyleType: "disc",
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                        className="ml-2 mr-2 pt-3 pb-2 pr-2 pl-4"
                      >
                        <li>
                          {" "}
                          <div className="flex text-[12px] font-medium">
                            Download a{" "}
                            <p className="ml-1 mr-1 text-[#0ba5ec]">template</p>{" "}
                            and compare it to your import file to ensure the
                            file perfect for the import
                          </div>
                        </li>
                        <li>Import data with the details of purchase list</li>
                        <li>
                          If you have files in another formats, you can convert
                          it to an accepted file format using any online/offline
                          converter
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

SalesReturnImport.propTypes = {
  location: PropTypes.any,
};

export default SalesReturnImport;
